// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/password_push/v1/password_push_flow.proto" (package "c1.api.password_push.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
// ====== Messages ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowRule
 */
export interface PasswordPushFlowRule {
    /**
     * @generated from protobuf field: int32 min_character_count = 1;
     */
    minCharacterCount: number;
    /**
     * @generated from protobuf field: int32 max_character_count = 2;
     */
    maxCharacterCount: number;
    /**
     * @generated from protobuf field: bool require_uppercase = 3;
     */
    requireUppercase: boolean;
    /**
     * @generated from protobuf field: bool require_numbers = 4;
     */
    requireNumbers: boolean;
    /**
     * @generated from protobuf field: bool require_special_characters = 5;
     */
    requireSpecialCharacters: boolean;
    /**
     * @generated from protobuf field: bool require_lowercase = 6;
     */
    requireLowercase: boolean;
    /**
     * @generated from protobuf oneof: character_rules
     */
    characterRules: {
        oneofKind: "noRestrictions";
        /**
         * @generated from protobuf field: bool no_restrictions = 100;
         */
        noRestrictions: boolean;
    } | {
        oneofKind: "customCharacters";
        /**
         * @generated from protobuf field: string custom_characters = 101;
         */
        customCharacters: string;
    } | {
        oneofKind: "excludedCharacters";
        /**
         * @generated from protobuf field: string excluded_characters = 102;
         */
        excludedCharacters: string;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlow
 */
export interface PasswordPushFlow {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @deprecated
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushFlowRule rule = 4 [deprecated = true];
     */
    rule?: PasswordPushFlowRule;
    /**
     * @generated from protobuf field: string password_policy_id = 5;
     */
    passwordPolicyId: string;
    /**
     * @generated from protobuf field: bool visible_to_everyone = 6;
     */
    visibleToEveryone: boolean;
}
/**
 * ====== Password Policies ======
 *
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicy
 */
export interface PasswordPolicy {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushFlowRule rule = 4;
     */
    rule?: PasswordPushFlowRule;
    /**
     * Whether this password policy is a builtin system policy. Builtin system policies cannot be deleted.
     *
     * @generated from protobuf field: bool system_builtin = 5;
     */
    systemBuiltin: boolean;
}
// ====== Create ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceCreateRequest
 */
export interface PasswordPushFlowServiceCreateRequest {
    /**
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @deprecated
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushFlowRule rule = 3 [deprecated = true];
     */
    rule?: PasswordPushFlowRule;
    /**
     * @generated from protobuf field: string password_policy_id = 4;
     */
    passwordPolicyId: string;
    /**
     * @generated from protobuf field: bool visible_to_everyone = 5;
     */
    visibleToEveryone: boolean;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceCreateResponse
 */
export interface PasswordPushFlowServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushFlow password_push_flow = 1;
     */
    passwordPushFlow?: PasswordPushFlow;
}
// ====== Get ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceGetRequest
 */
export interface PasswordPushFlowServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceGetResponse
 */
export interface PasswordPushFlowServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushFlow password_push_flow = 1;
     */
    passwordPushFlow?: PasswordPushFlow;
}
// ====== Update ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceUpdateRequest
 */
export interface PasswordPushFlowServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushFlow password_push_flow = 1;
     */
    passwordPushFlow?: PasswordPushFlow;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceUpdateResponse
 */
export interface PasswordPushFlowServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushFlow password_push_flow = 1;
     */
    passwordPushFlow?: PasswordPushFlow;
}
// ====== Delete ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceDeleteRequest
 */
export interface PasswordPushFlowServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceDeleteResponse
 */
export interface PasswordPushFlowServiceDeleteResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
// ====== Initiate Password Push Flow ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceInitiateRequest
 */
export interface PasswordPushFlowServiceInitiateRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1;
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string password_push_flow_id = 2;
     */
    passwordPushFlowId: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceInitiateResponse
 */
export interface PasswordPushFlowServiceInitiateResponse {
    /**
     * @generated from protobuf field: string target_user_id = 1;
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string password_push_flow_id = 2;
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: string password_push_flow_invocation_id = 3;
     */
    passwordPushFlowInvocationId: string;
    /**
     * @generated from protobuf field: string jwk = 4;
     */
    jwk: string;
}
// ====== Complete Password Push Flow ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceCompleteRequest
 */
export interface PasswordPushFlowServiceCompleteRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1;
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string password_push_flow_id = 2;
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: string password_push_flow_invocation_id = 3;
     */
    passwordPushFlowInvocationId: string;
    /**
     * @generated from protobuf field: string jwe_encrypted_password = 4;
     */
    jweEncryptedPassword: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceCompleteResponse
 */
export interface PasswordPushFlowServiceCompleteResponse {
}
/**
 * ====== Password Policies ======
 *
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicyServiceCreateRequest
 */
export interface PasswordPolicyServiceCreateRequest {
    /**
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushFlowRule rule = 3;
     */
    rule?: PasswordPushFlowRule;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicyServiceCreateResponse
 */
export interface PasswordPolicyServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPolicy password_policy = 1;
     */
    passwordPolicy?: PasswordPolicy;
}
/**
 * ====== Get Password Policy ======
 *
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicyServiceGetRequest
 */
export interface PasswordPolicyServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicyServiceGetResponse
 */
export interface PasswordPolicyServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPolicy password_policy = 1;
     */
    passwordPolicy?: PasswordPolicy;
}
/**
 * ====== Update Password Policy ======
 *
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicyServiceUpdateRequest
 */
export interface PasswordPolicyServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPolicy password_policy = 1;
     */
    passwordPolicy?: PasswordPolicy;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicyServiceUpdateResponse
 */
export interface PasswordPolicyServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPolicy password_policy = 1;
     */
    passwordPolicy?: PasswordPolicy;
}
// ====== Delete Password Policy ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicyServiceDeleteRequest
 */
export interface PasswordPolicyServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicyServiceDeleteResponse
 */
export interface PasswordPolicyServiceDeleteResponse {
}
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowRule$Type extends MessageType<PasswordPushFlowRule> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowRule", [
            { no: 1, name: "min_character_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "max_character_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "require_uppercase", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "require_numbers", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "require_special_characters", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "require_lowercase", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 100, name: "no_restrictions", kind: "scalar", oneof: "characterRules", T: 8 /*ScalarType.BOOL*/ },
            { no: 101, name: "custom_characters", kind: "scalar", oneof: "characterRules", T: 9 /*ScalarType.STRING*/ },
            { no: 102, name: "excluded_characters", kind: "scalar", oneof: "characterRules", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowRule
 */
export const PasswordPushFlowRule = new PasswordPushFlowRule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlow$Type extends MessageType<PasswordPushFlow> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlow", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "rule", kind: "message", T: () => PasswordPushFlowRule },
            { no: 5, name: "password_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "visible_to_everyone", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlow
 */
export const PasswordPushFlow = new PasswordPushFlow$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicy$Type extends MessageType<PasswordPolicy> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicy", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "rule", kind: "message", T: () => PasswordPushFlowRule },
            { no: 5, name: "system_builtin", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicy
 */
export const PasswordPolicy = new PasswordPolicy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceCreateRequest$Type extends MessageType<PasswordPushFlowServiceCreateRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceCreateRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "rule", kind: "message", T: () => PasswordPushFlowRule },
            { no: 4, name: "password_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "visible_to_everyone", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceCreateRequest
 */
export const PasswordPushFlowServiceCreateRequest = new PasswordPushFlowServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceCreateResponse$Type extends MessageType<PasswordPushFlowServiceCreateResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceCreateResponse", [
            { no: 1, name: "password_push_flow", kind: "message", T: () => PasswordPushFlow }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceCreateResponse
 */
export const PasswordPushFlowServiceCreateResponse = new PasswordPushFlowServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceGetRequest$Type extends MessageType<PasswordPushFlowServiceGetRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceGetRequest
 */
export const PasswordPushFlowServiceGetRequest = new PasswordPushFlowServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceGetResponse$Type extends MessageType<PasswordPushFlowServiceGetResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceGetResponse", [
            { no: 1, name: "password_push_flow", kind: "message", T: () => PasswordPushFlow }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceGetResponse
 */
export const PasswordPushFlowServiceGetResponse = new PasswordPushFlowServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceUpdateRequest$Type extends MessageType<PasswordPushFlowServiceUpdateRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceUpdateRequest", [
            { no: 1, name: "password_push_flow", kind: "message", T: () => PasswordPushFlow },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceUpdateRequest
 */
export const PasswordPushFlowServiceUpdateRequest = new PasswordPushFlowServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceUpdateResponse$Type extends MessageType<PasswordPushFlowServiceUpdateResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceUpdateResponse", [
            { no: 1, name: "password_push_flow", kind: "message", T: () => PasswordPushFlow }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceUpdateResponse
 */
export const PasswordPushFlowServiceUpdateResponse = new PasswordPushFlowServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceDeleteRequest$Type extends MessageType<PasswordPushFlowServiceDeleteRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceDeleteRequest
 */
export const PasswordPushFlowServiceDeleteRequest = new PasswordPushFlowServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceDeleteResponse$Type extends MessageType<PasswordPushFlowServiceDeleteResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceDeleteResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceDeleteResponse
 */
export const PasswordPushFlowServiceDeleteResponse = new PasswordPushFlowServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceInitiateRequest$Type extends MessageType<PasswordPushFlowServiceInitiateRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceInitiateRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceInitiateRequest
 */
export const PasswordPushFlowServiceInitiateRequest = new PasswordPushFlowServiceInitiateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceInitiateResponse$Type extends MessageType<PasswordPushFlowServiceInitiateResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceInitiateResponse", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "password_push_flow_invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "jwk", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceInitiateResponse
 */
export const PasswordPushFlowServiceInitiateResponse = new PasswordPushFlowServiceInitiateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceCompleteRequest$Type extends MessageType<PasswordPushFlowServiceCompleteRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceCompleteRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "password_push_flow_invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "jwe_encrypted_password", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceCompleteRequest
 */
export const PasswordPushFlowServiceCompleteRequest = new PasswordPushFlowServiceCompleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceCompleteResponse$Type extends MessageType<PasswordPushFlowServiceCompleteResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceCompleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceCompleteResponse
 */
export const PasswordPushFlowServiceCompleteResponse = new PasswordPushFlowServiceCompleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicyServiceCreateRequest$Type extends MessageType<PasswordPolicyServiceCreateRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicyServiceCreateRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "rule", kind: "message", T: () => PasswordPushFlowRule }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicyServiceCreateRequest
 */
export const PasswordPolicyServiceCreateRequest = new PasswordPolicyServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicyServiceCreateResponse$Type extends MessageType<PasswordPolicyServiceCreateResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicyServiceCreateResponse", [
            { no: 1, name: "password_policy", kind: "message", T: () => PasswordPolicy }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicyServiceCreateResponse
 */
export const PasswordPolicyServiceCreateResponse = new PasswordPolicyServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicyServiceGetRequest$Type extends MessageType<PasswordPolicyServiceGetRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicyServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicyServiceGetRequest
 */
export const PasswordPolicyServiceGetRequest = new PasswordPolicyServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicyServiceGetResponse$Type extends MessageType<PasswordPolicyServiceGetResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicyServiceGetResponse", [
            { no: 1, name: "password_policy", kind: "message", T: () => PasswordPolicy }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicyServiceGetResponse
 */
export const PasswordPolicyServiceGetResponse = new PasswordPolicyServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicyServiceUpdateRequest$Type extends MessageType<PasswordPolicyServiceUpdateRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicyServiceUpdateRequest", [
            { no: 1, name: "password_policy", kind: "message", T: () => PasswordPolicy },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicyServiceUpdateRequest
 */
export const PasswordPolicyServiceUpdateRequest = new PasswordPolicyServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicyServiceUpdateResponse$Type extends MessageType<PasswordPolicyServiceUpdateResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicyServiceUpdateResponse", [
            { no: 1, name: "password_policy", kind: "message", T: () => PasswordPolicy }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicyServiceUpdateResponse
 */
export const PasswordPolicyServiceUpdateResponse = new PasswordPolicyServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicyServiceDeleteRequest$Type extends MessageType<PasswordPolicyServiceDeleteRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicyServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicyServiceDeleteRequest
 */
export const PasswordPolicyServiceDeleteRequest = new PasswordPolicyServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicyServiceDeleteResponse$Type extends MessageType<PasswordPolicyServiceDeleteResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicyServiceDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicyServiceDeleteResponse
 */
export const PasswordPolicyServiceDeleteResponse = new PasswordPolicyServiceDeleteResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.password_push.v1.PasswordPushFlowService
 */
export const PasswordPushFlowService = new ServiceType("c1.api.password_push.v1.PasswordPushFlowService", [
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: PasswordPushFlowServiceCreateRequest, O: PasswordPushFlowServiceCreateResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPushFlowServiceGetRequest, O: PasswordPushFlowServiceGetResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: PasswordPushFlowServiceUpdateRequest, O: PasswordPushFlowServiceUpdateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: PasswordPushFlowServiceDeleteRequest, O: PasswordPushFlowServiceDeleteResponse },
    { name: "Initiate", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPushFlowServiceInitiateRequest, O: PasswordPushFlowServiceInitiateResponse },
    { name: "Complete", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPushFlowServiceCompleteRequest, O: PasswordPushFlowServiceCompleteResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.password_push.v1.PasswordPolicyService
 */
export const PasswordPolicyService = new ServiceType("c1.api.password_push.v1.PasswordPolicyService", [
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: PasswordPolicyServiceCreateRequest, O: PasswordPolicyServiceCreateResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPolicyServiceGetRequest, O: PasswordPolicyServiceGetResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: PasswordPolicyServiceUpdateRequest, O: PasswordPolicyServiceUpdateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: PasswordPolicyServiceDeleteRequest, O: PasswordPolicyServiceDeleteResponse }
]);
